import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const Svg1Persoon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#1-Persoon_svg__a)">
      <mask
        id="1-Persoon_svg__b"
        width={12}
        height={28}
        x={14}
        y={6}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M21.22 18a6 6 0 1 0-2.44 0A6 6 0 0 0 14 23.88v10h12v-10A6 6 0 0 0 21.22 18"
        />
      </mask>
      <g mask="url(#1-Persoon_svg__b)">
        <path
          fill="#F18700"
          d="m6.96 3.72 12.24 7.07-7.07 12.25zM31.45 17.86 19.2 10.79l7.07-12.25z"
        />
        <path
          fill="#F18700"
          d="M26.27-1.46 19.2 10.79 6.96 3.72z"
        />
        <path
          fill="#F7A941"
          d="m12.13 23.04 7.07-12.25 12.25 7.07zM17.31 42.35 5.06 35.28l7.07-12.24z"
        />
        <path
          fill="#F18700"
          d="m36.63 37.18-12.25-7.07 7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="m12.13 23.04 12.25 7.07-7.07 12.24z"
        />
        <path
          fill="#F7A941"
          d="m17.31 42.35 7.07-12.24 12.25 7.07z"
        />
        <path
          fill="#F18700"
          d="m31.45 17.86-7.07 12.25-12.25-7.07z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="1-Persoon_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(Svg1Persoon);

export default ForwardRef;
